// In this component we handle site removal popup and call its api

import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import {
  buySearchCreditTexts,
  defaultContentSiteAudit,
  paths,
  upgradePlanModalTexts
} from 'src/common/config/TextMessage';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
import { upgradeWarningPlanSx } from '../../common/CommomSxs';
import CommonModal from 'src/common/config/CommonModal';
import { AvatarGroupModule } from 'src/common/AvatarGroupsModule';
import { RootState } from 'src/redux/store';
import { handleInterComClick } from 'src/common/config/FunctionHelper';

const UpgradeModalForSiteAudit = ({
  showUpgradeModal,
  handleCloseUpgradeModal,
  setShowUpgradeModal,
  isLocalSeo = false,
  isFromRunOutOfScan = false
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency = activePlanName === planDetails?.agency;
  const isExpertPlus = activePlanName === planDetails?.expertPlus;
  const isEnterprise = activePlanName === planDetails?.enterprise;
  const pathKey = location.pathname.split('/').pop(); // Extract the last part of the path
  // const content = upgradePlanWarnContent[pathKey] || defaultContent;
  const content = defaultContentSiteAudit;
  const handleCloseModal = () => {
    setShowUpgradeModal(false);
    handleCloseUpgradeModal();
  };
  useEffect(() => {
    setLoading(false);
  }, []);

  const btnText =
    isAgency || isEnterprise
    // isExpertPlus || isEnterprise
      ? upgradePlanModalTexts?.contactUs
      : upgradePlanModalTexts?.upgradePlan;
  const showFunction = () => {
    return (
      <Fragment>
        <div>
          <Typography sx={upgradeWarningPlanSx?.subHeader}>
            {isFromRunOutOfScan
              ? `Free plans include up to 50 scans. To keep scanning Squarespace URLs and get more SEO insights, upgrade your plan to unlock unlimited scans.`
              : isLocalSeo
              ? buySearchCreditTexts?.descLocalSeo
              : content.subHeader}
          </Typography>
          <Box sx={upgradeWarningPlanSx?.avatarBox}>
            <Typography sx={upgradeWarningPlanSx?.joinWith}>
              {upgradePlanModalTexts?.joinWithText}
            </Typography>
            <AvatarGroupModule />
          </Box>
          <div className="flex space-x-5  mt-5 justify-center h-10 mb-4">
            <Button
              variant="contained"
              // size="medium"
              sx={upgradeWarningPlanSx?.btnSx}
              disabled={loading}
              onClick={() => {
                if (isAgency || isEnterprise) {
                // if (isExpertPlus || isEnterprise) {
                  handleInterComClick();
                } else {
                  setLoading(true);
                  handleCloseModal();
                  dispatch(setIsOpenChangePlan(true));
                  navigate(paths?.billing);
                }
              }}
            >
              {' '}
              {loading ? <CircularProgress size={24} /> : btnText}
            </Button>
          </div>
        </div>
      </Fragment>
    );
  };
  return (
    <CommonModal
      open={showUpgradeModal}
      handCloseModal={handleCloseModal}
      title={
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: 'var(--font-size-20)',
            fontWeight: 800,
            lineHeight: 'var(--line-height-30)',
            textAlign: 'left',
            color: 'var(--color-primary)'
          }}
        >
          {isFromRunOutOfScan
            ? "You've Reached Your Scan Limit"
            : isLocalSeo
            ? buySearchCreditTexts?.modalTitleLocalSeo
            : content.title}
        </Typography>
      }
      closebtn={true}
    >
      {showFunction()}
    </CommonModal>
  );
};
export default UpgradeModalForSiteAudit;
